import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

export default function HeroSection() {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 0.5;
    }
  }, []);

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Video */}
      <div className="absolute inset-0">
        <video
          ref={videoRef}
          autoPlay
          muted
          loop
          playsInline
          className="w-full h-full object-cover object-center"
        >
          <source
            src="https://videos.pexels.com/video-files/3248188/3248188-hd_1920_1080_25fps.mp4"
            type="video/mp4"
          />
          {/* Fallback image if video fails to load */}
          <img
            src="https://res.cloudinary.com/dtxnjaa8b/image/upload/q_auto/f_auto/v1775093596/ChatGPT_Image_Apr_2_2026_04_26_39_AM_oh20p1.png"
            alt="Community Empowerment"
            className="w-full h-full object-cover object-top"
          />
        </video>
        <div className="absolute inset-0 bg-gradient-to-r from-[#003366]/90 via-[#003366]/70 to-[#003366]/30" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-16">
        <div className="max-w-2xl">
          <span className="inline-block px-3 py-1 bg-[#ADD8E6]/20 border border-[#ADD8E6]/40 rounded-full text-[#ADD8E6] text-xs font-semibold uppercase tracking-widest mb-6">
            Empowering Communities Since 2024
          </span>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            Building Hope,
            <br />
            <span className="text-[#ADD8E6]">Transforming Lives</span>
            <br />
            in Uganda
          </h1>
          <p className="text-lg text-white/80 leading-relaxed mb-10 max-w-xl">
             Hands to serve, Hearts to care
          </p>
          <div className="flex flex-wrap gap-4">
            <Link
              to="/donate"
              className="px-8 py-3.5 bg-[#ADD8E6] text-[#003366] font-bold text-sm rounded-lg hover:bg-white transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              Donate Now
            </Link>
            <Link
              to="/programs"
              className="px-8 py-3.5 border-2 border-white text-white font-semibold text-sm rounded-lg hover:bg-white hover:text-[#003366] transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              Explore Programs
            </Link>
            <Link
              to="/contact"
              className="px-8 py-3.5 bg-white/10 backdrop-blur text-white font-semibold text-sm rounded-lg hover:bg-white/20 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              Partner With Us
            </Link>
          </div>
        </div>
        {/* Responsive Image */}
        <div className="mt-10 w-full max-w-md mx-auto lg:max-w-2xl lg:mx-0 lg:absolute lg:right-8 lg:top-1/2 lg:-translate-y-1/2">
          <img
            src="https://res.cloudinary.com/dtxnjaa8b/image/upload/q_auto/f_auto/v1775093596/ChatGPT_Image_Apr_2_2026_04_26_39_AM_oh20p1.png"
            alt="Community Empowerment"
            className="w-full h-auto rounded-lg shadow-2xl object-cover"
          />
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <div className="w-8 h-8 flex items-center justify-center text-white/60">
          <i className="ri-arrow-down-line text-xl" />
        </div>
      </div>
    </section>
  );
}
